import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Form, Page, Text } from '@fielded/shared-ui'
import EntryViewWrapper from '../common/EntryViewWrapper'

const ResetPassword = ({
  config,
  onSuccess,
  onSubmit,
  inProcess,
  error
}) => {
  return (
    <EntryViewWrapper config={config}>
      {!onSuccess && (
        <Fragment>
          <Page.Panel.Section>
            <div className='login__panel-title'>
              Choose a new password
            </div>
          </Page.Panel.Section>

          {error && (
            <Page.Panel.Message type='danger' cta={false}>
              {error}
            </Page.Panel.Message>
          )}

          <Page.Panel.Section>
            <Text>
              Type your new password below.
            </Text>
          </Page.Panel.Section>

          <Page.Panel.Section>
            <Form
              onSubmit={onSubmit}
              component='form'
            >
              <Form.Row>
                <Form.Field
                  fieldName='password'
                  labelText='Enter your new password'
                >
                  <Form.Field.Text
                    maxlength={64}
                    type='password'
                    required
                    disabled={inProcess}
                    autoCapitalize='off'
                  />
                  <Form.Field.ValidationErrors />
                </Form.Field>
              </Form.Row>

              <Form.Row>
                <Form.Field
                  fieldName='confirmPassword'
                  labelText='Re-type password'
                >
                  <Form.Field.Text
                    maxlength={64}
                    type='password'
                    required
                    disabled={inProcess}
                    autoCapitalize='off'
                  />
                  <Form.Field.ValidationErrors />
                </Form.Field>
              </Form.Row>

              <Form.Actions>
                <Form.Button
                  alignOpposite
                  size='medium'
                  disabled={inProcess}
                  loading={inProcess}
                >
                  Reset password
                </Form.Button>
              </Form.Actions>
            </Form>
          </Page.Panel.Section>
        </Fragment>
      )}
    </EntryViewWrapper>
  )
}

ResetPassword.propTypes = {
  config: PropTypes.object.isRequired,
  loginInProgress: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
}

ResetPassword.defaultProps = {
  loginInProgress: false,
  errorMessage: null
}

export default ResetPassword
